import { formatInTimeZone } from 'date-fns-tz';
const DEFAULT_TIMEZONE = 'UTC';
export const formatDate = (dt, dtFormat = 'yyyy-MM-dd', timezone = DEFAULT_TIMEZONE) => {
    if (!dt)
        return '-';
    return formatInTimeZone(dt, timezone, dtFormat);
};
export const parseDate = (dt) => {
    if (!dt)
        return null;
    if (typeof dt === 'string') {
        return new Date(dt.replace(/-/g, '/'));
    }
    return dt;
};
export const formatFullDate = (dt, defaultValue = '', timezone = DEFAULT_TIMEZONE, includeTimezone = false) => {
    if (!dt)
        return defaultValue;
    return formatInTimeZone(typeof dt === 'string' ? new Date(`${dt}Z`) : dt, timezone, `yyyy-MM-dd h:mm:ss aaa${includeTimezone ? ' zzz' : ''}`);
};
/**
 * Get the local date from a date string. The input is assumed to be just the date without any time components.
 *
 * If the input has just the date, it treats the date as UTC.
 * e.g. when running in the US Pacific timezone:
 *  new Date('2024-10-16')          => Tue Oct 15 2024 17:00:00 GMT-0700 (Pacific Daylight Time)
 *  new Date('2024-10-16T00:00:00') => Wed Oct 16 2024 00:00:00 GMT-0700 (Pacific Daylight Time)
 *
 * To avoid the above issue, this function adds the time part
 *
 * @param dt - The date string.
 * @returns The local date, or undefined if the input is undefined, null, or an empty string.
 */
export const getLocalDate = (dt) => {
    if (!dt)
        return;
    if (dt.length === 10) {
        dt = `${dt}T00:00:00`;
    }
    return new Date(dt);
};
